var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Page 1 Copy 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95014 4.5L8.60013 4.5V9.9L13.3206 12.735L14.0001 11.628L9.95014 9.225V4.5ZM9.49973 16.2001C5.52173 16.2001 2.29973 12.9781 2.29973 9.00007C2.29973 5.02207 5.52173 1.80007 9.49973 1.80007C13.4777 1.80007 16.6997 5.02207 16.6997 9.00007C16.6997 12.9781 13.4777 16.2001 9.49973 16.2001ZM9.4955 0C4.523 0 0.5 4.0275 0.5 9C0.5 13.9725 4.523 18 9.4955 18C14.468 18 18.5 13.9725 18.5 9C18.5 4.0275 14.468 0 9.4955 0Z",
    fill: "#106C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.d8450d055165a28241c4158d29b27a96.svg";
export { ForwardRef as ReactComponent };